import React, { useState } from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { PAYOUT, PAGE_LIMIT } from "helpers/viewContent";
import {  DATE_FORMAT_TIME } from "helpers/common";
//imported
import * as Path from "routes/paths";

const Listing = ({ dispatch, itemsCountPerPage, totalItemsCount }) => {
  //pagination
  const [activePage, setActivePage] = useState(1);
  const [filter, setFilter] = useState({
    page: activePage,
    limit: PAGE_LIMIT,
  });
  const data = [
    { coach: "Rohan", paid_amount: "$100", status: "completed", created_at: "2024-02-08 12:21:32" },
    { coach: "john", paid_amount: "$150", status: "completed", created_at: "2024-02-09 12:21:32" },
  ];

  const [listing, setListing] = useState(data);

  return (
    <>
      <Helmet title={PAYOUT.CURRENT_MODULE} />
      <div className="page-header">
        <h3 className="page-title">
          <span className="page-title-icon bg-gradient-primary text-white me-2">
            <i className="mdi mdi-view-stream menu-icon"></i>
          </span>{" "}
          {PAYOUT.CURRENT_MODULE}
        </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={Path.manage_payouts}>{PAYOUT.CURRENT_MODULE}</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Listing
            </li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">
                <div className="row">
                  <div className="col-md-6">Listing</div>
                  <div className="col-md-4"></div>
                </div>
              </h4>
              <div class="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th> Coach </th>
                      <th> Pain Amount </th>
                      <th> Status </th>
                      <th> Paid Date </th>
                    </tr>
                  </thead>
                  <tbody>
                    {listing?.length > 0 &&
                      listing.map((list, i) => {
                        return (
                          <tr key={i}>
                            <td>{list.coach}</td>
                            <td>{list.paid_amount}</td>
                            <td>{list.status}</td>
                            <td className="py-1">
                              {list?.created_at ? DATE_FORMAT_TIME(list?.created_at) : "N/A"}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
              {listing.length == 0 && (
                <div className="row">
                  <div className="col-md-6 pt-5">
                    <span>No data found...</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToPros = (state) => {
  return {
    itemsCountPerPage: state.Faq.itemsCountPerPage,
    totalItemsCount: state.Faq.totalItemsCount,
    loader: state.Faq.loader,
  };
};
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(Listing);
